import { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { useSoyuzExperiment } from '@spotahome/soyuz/client';

const InteractiveMapMapbox = lazy(() => import('../InteractiveMap'));
const InteractiveMapGoogle = lazy(() =>
  import('../InteractiveMap/index.google')
);

const SliderTrackMap = props => {
  const mapProviderVariant = useSoyuzExperiment('MapboxAsMapProvider').get(
    'behaviour'
  );
  const InteractiveMap =
    mapProviderVariant === 'variant'
      ? InteractiveMapMapbox
      : InteractiveMapGoogle;

  return (
    <Suspense fallback={null}>
      <InteractiveMap {...props.item} mapId="slider-map" />
    </Suspense>
  );
};

SliderTrackMap.propTypes = {
  item: PropTypes.shape({
    coords: PropTypes.arrayOf(PropTypes.number),
    countryCode: PropTypes.string,
    areaSlug: PropTypes.string
  }).isRequired
};

export default SliderTrackMap;
